import { Banner } from "@/components/ui/Banner";

export enum BannerState {
  PROCESSING = "processing",
  SUCCESS = "success",
  SUCCESS_PLAN_CHANGED = "success_plan_changed",
  CANCEL = "cancel",
}

interface SubscriptionBannerProps {
  bannerState: BannerState | null;
  onDismiss: () => void;
}

export const SubscriptionBanner = ({ bannerState, onDismiss }: SubscriptionBannerProps) => {
  if (!bannerState) return null;

  if (bannerState === BannerState.PROCESSING) {
    return (
      <Banner
        variant="info"
        message="Your payment is currently being processed and may take some time to complete."
        onDismiss={onDismiss}
      />
    );
  } else if (bannerState === BannerState.SUCCESS) {
    return (
      <Banner
        variant="success"
        message="Your subscription has been successfully activated!"
        onDismiss={onDismiss}
      />
    );
  } else if (bannerState === BannerState.SUCCESS_PLAN_CHANGED) {
    return (
      <Banner
        variant="success"
        message="Your subscription plan has been successfully changed."
        onDismiss={onDismiss}
      />
    );
  } else if (bannerState === BannerState.CANCEL) {
    return (
      <Banner
        variant="warning"
        message="Your payment has been cancelled. In case any amount was deducted during processing, it will be refunded to your account within a few business days."
        onDismiss={onDismiss}
      />
    );
  }
};
